import {
  EditWaypointsIcon,
  FaroTooltip,
} from "@faro-lotv/app-component-toolbox";
import { SxProps, Theme } from "@mui/material";
import type { JSX } from "react";
import { EmbeddedToolbarButton } from "../../../ui/embedded-toolbar";

export type MinimapEditButtonProps = {
  /** Whether the edit button should be shown. */
  isAllowedToEdit: boolean;

  /** Whether the minimap is in editing mode. */
  isEditing: boolean;

  /** Whether the minimap container is being hovered. */
  isContainerHovered: boolean;

  /** Callback when the user requests to toggle the edit mode. */
  onToggleEditing(): void;

  /** Custom styling applied to the button. */
  sx?: SxProps<Theme>;
};

/**
 * @returns A button to enter the edit waypoints mode in the minimap.
 */
export function MinimapEditWaypointsButton({
  isAllowedToEdit,
  isEditing,
  isContainerHovered,
  onToggleEditing,
  sx,
}: MinimapEditButtonProps): JSX.Element | null {
  if (!isAllowedToEdit || isEditing) return null;

  return (
    <FaroTooltip title="Edit waypoints" placement="left">
      <EmbeddedToolbarButton
        aria-label="minimap edit waypoints"
        value={isEditing}
        onClick={onToggleEditing}
        sx={{
          opacity: isContainerHovered ? 1 : 0,
          transition: "opacity 0.2s",
          padding: 0.5,
          ...sx,
        }}
      >
        <EditWaypointsIcon
          sx={{
            fontSize: "18px",
          }}
        />
      </EmbeddedToolbarButton>
    </FaroTooltip>
  );
}
